import React from 'react';
import { FormCheckboxOption } from 'src/models/form-types';

interface FormCheckboxGroupProps {
  options: FormCheckboxOption[];
  selectedValues: string[];
  onChange: (name: string, checked: boolean) => void;
  columns?: 1 | 2 | 3;
}

export const FormCheckboxGroup: React.FC<FormCheckboxGroupProps> = ({
  options,
  selectedValues,
  onChange,
  columns = 1
}) => {
  const columnClass = columns === 1 ? '' : 
                      columns === 2 ? 'two-columns' : 'three-columns';
  
  return (
    <div className={`checkbox-group ${columnClass}`}>
      {options.map(option => {
        const isChecked = selectedValues.includes(option.name);
        
        return (
          <label 
            className={`checkbox-item ${isChecked ? 'selected' : ''}`} 
            key={option.id}
            htmlFor={option.id}
          >
            <input
              type="checkbox"
              id={option.id}
              name={option.name}
              checked={isChecked}
              onChange={(e) => onChange(option.name, e.target.checked)}
            />
            <div className="checkbox-custom"></div>
            <span className="checkbox-label">{option.label}</span>
          </label>
        );
      })}
    </div>
  );
};